(function () {
  'use strict';

  var RECENT_SELECTION_TTL = 20000;
  var CART_CACHE_TTL = 60000;
  var BODY_BLOCK_CLASS = 'fis-addon-popup-blocked';
  var HARD_HIDE_STYLE_ID = 'fis-addon-popup-hard-hide-style';
  var recentProductSelection = {
    ids: {},
    timestamp: 0
  };
  var cartAddonCache = { ids: {}, time: 0 };

  var ADDON_GROUPS = [
    {
      id: 'sofa_removal',
      keywords: [
        'sofa removal',
        'old sofa removal',
        'old furniture removal'
      ]
    },
    {
      id: 'care_protection',
      keywords: [
        '5 year care protection',
        'five year care protection',
        '5 year care protection plan',
        'five year care protection plan',
        '5 year cover',
        'five year cover',
        '5 year warranty',
        'five year warranty',
        'care protection plan',
        'protection plan'
      ]
    },
    {
      id: 'premier_delivery',
      keywords: [
        'premier delivery',
        'premier delivery service',
        'assembly and packaging recycling',
        'assembly packaging recycling',
        'packaging recycling'
      ]
    }
  ];

  function normalise(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\u2012\u2013\u2014\u2015-]/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matchAddonIds(text) {
    var n = normalise(text);
    var ids = {};

    if (!n) return ids;

    ADDON_GROUPS.forEach(function (group) {
      for (var i = 0; i < group.keywords.length; i++) {
        if (n.indexOf(normalise(group.keywords[i])) !== -1) {
          ids[group.id] = true;
          break;
        }
      }
    });

    return ids;
  }

  function matchSingleAddonId(text) {
    var ids = matchAddonIds(text);
    var keys = Object.keys(ids);

    return keys.length === 1 ? keys[0] : null;
  }

  function mergeIds(target, source) {
    Object.keys(source || {}).forEach(function (id) {
      target[id] = true;
    });

    return target;
  }

  function hasAddonIds(ids) {
    return Object.keys(ids || {}).length > 0;
  }

  function setPopupBlockState(enabled) {
    if (!document.body) return;

    document.body.classList.toggle(BODY_BLOCK_CLASS, Boolean(enabled));
  }

  function setRecentProductSelections(ids) {
    recentProductSelection = {
      ids: ids || {},
      timestamp: hasAddonIds(ids) ? Date.now() : 0
    };

    setPopupBlockState(hasAddonIds(ids));
  }

  function installHardHideStyles() {
    if (document.getElementById(HARD_HIDE_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = HARD_HIDE_STYLE_ID;
    style.textContent =
      '[data-fis-popup-blocked="true"]{' +
      'opacity:0!important;' +
      'visibility:hidden!important;' +
      'pointer-events:none!important;' +
      'transition:none!important;' +
      'animation:none!important;' +
      '}' +
      'body.' +
      BODY_BLOCK_CLASS +
      ' [role="dialog"]:has(input[type="checkbox"]),' +
      'body.' +
      BODY_BLOCK_CLASS +
      ' [aria-modal="true"]:has(input[type="checkbox"]){' +
      'opacity:0!important;' +
      'visibility:hidden!important;' +
      'pointer-events:none!important;' +
      'transition:none!important;' +
      'animation:none!important;' +
      '}';

    document.head.appendChild(style);
  }

  function collectIdsFromText(target, text) {
    mergeIds(target, matchAddonIds(text));
  }

  function updateCartCache(ids) {
    cartAddonCache = { ids: ids || {}, time: Date.now() };
    if (hasAddonIds(ids)) setPopupBlockState(true);
  }

  function getCachedCartIds() {
    if (Date.now() - cartAddonCache.time < CART_CACHE_TTL) return cartAddonCache.ids;
    return {};
  }

  async function getCartAddonIds() {
    var active = {};

    try {
      var res = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!res.ok) return active;

      var cart = await res.json();

      (cart.items || []).forEach(function (item) {
        collectIdsFromText(
          active,
          [item.title, item.product_title, item.variant_title].join(' ')
        );

        var props = item.properties || {};
        Object.keys(props).forEach(function (key) {
          var value = props[key];

          if (value === null || value === false || value === '') return;

          collectIdsFromText(active, key + ' ' + value);
        });
      });
    } catch (error) {
      return active;
    }

    return active;
  }

  function isPopupRoot(el) {
    if (!el || el === document.body) return false;

    var text = normalise(el.textContent);

    return (
      text.indexOf('you might also like') !== -1 &&
      (text.indexOf('skip this offer') !== -1 ||
        text.indexOf('add items to cart') !== -1) &&
      Boolean(el.querySelector('input[type="checkbox"], input[type="radio"]'))
    );
  }

  function addUnique(list, item) {
    if (list.indexOf(item) === -1) list.push(item);
  }

  function findPopupRoots() {
    var roots = [];

    if (normalise(document.body.textContent).indexOf('you might also like') === -1) {
      return roots;
    }

    var nodes = document.querySelectorAll('body *');

    nodes.forEach(function (node) {
      if (normalise(node.textContent).indexOf('you might also like') === -1) {
        return;
      }

      var el = node;

      while (el && el !== document.body) {
        if (isPopupRoot(el)) {
          addUnique(roots, el);
          break;
        }

        el = el.parentElement;
      }
    });

    return roots.filter(function (root) {
      return !roots.some(function (other) {
        return root !== other && root.contains(other);
      });
    });
  }

  function isVisibleOverlayShell(el) {
    if (!el || el === document.body) return false;

    var style = window.getComputedStyle(el);
    var rect = el.getBoundingClientRect();
    var coversMostViewport =
      rect.width >= window.innerWidth * 0.7 && rect.height >= window.innerHeight * 0.7;

    return (
      el.getAttribute('role') === 'dialog' ||
      el.getAttribute('aria-modal') === 'true' ||
      (style.position === 'fixed' && coversMostViewport)
    );
  }

  function getPopupShell(root) {
    var el = root;

    while (el && el !== document.body) {
      if (isVisibleOverlayShell(el)) return el;
      el = el.parentElement;
    }

    return root;
  }

  function hardHidePopupRoot(root) {
    var shell = getPopupShell(root);

    [root, shell].forEach(function (el) {
      if (!el) return;

      el.dataset.fisPopupBlocked = 'true';
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('transition', 'none', 'important');
      el.style.setProperty('animation', 'none', 'important');
    });
  }

  function findPopupRootsInNode(node) {
    var roots = [];
    var startNode = node instanceof Element ? node : node && node.parentElement;

    if (!(startNode instanceof Element)) return roots;

    [startNode].concat(Array.prototype.slice.call(startNode.querySelectorAll('*'))).forEach(function (el) {
      if (normalise(el.textContent).indexOf('you might also like') === -1) return;

      var current = el;

      while (current && current !== document.body) {
        if (isPopupRoot(current)) {
          addUnique(roots, current);
          break;
        }

        current = current.parentElement;
      }
    });

    return roots.filter(function (root) {
      return !roots.some(function (other) {
        return root !== other && root.contains(other);
      });
    });
  }

  function getBlockingAddonIds(popupRoots) {
    var activeIds = mergeIds({}, getSelectedProductAddonIds(popupRoots || []));

    mergeIds(activeIds, getRecentProductSelections());

    return activeIds;
  }

  function isInsidePopup(el, popupRoots) {
    return popupRoots.some(function (root) {
      return root.contains(el);
    });
  }

  function getLabelText(input) {
    var parts = [];

    if (input.id) {
      document.querySelectorAll('label[for]').forEach(function (label) {
        if (label.htmlFor === input.id) parts.push(label.textContent || '');
      });
    }

    var wrappedLabel = input.closest('label');
    if (wrappedLabel) parts.push(wrappedLabel.textContent || '');

    return parts.join(' ');
  }

  function matchInputAddonId(input) {
    var id = matchSingleAddonId(
      [
        input.name,
        input.value,
        input.getAttribute('aria-label'),
        input.getAttribute('data-title'),
        input.getAttribute('data-product-title'),
        input.getAttribute('data-name'),
        getLabelText(input)
      ].join(' ')
    );

    if (id) return id;

    var el = input.parentElement;
    var depth = 0;

    while (el && el !== document.body && depth < 8) {
      var text = el.textContent || '';

      if (text.length < 1200) {
        id = matchSingleAddonId(text);
        if (id) return id;
      }

      el = el.parentElement;
      depth++;
    }

    return null;
  }

  function getSelectedProductAddonIds(popupRoots) {
    var active = {};

    document
      .querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
      .forEach(function (input) {
        if (input.disabled || isInsidePopup(input, popupRoots)) return;

        var id = matchInputAddonId(input);
        if (id) active[id] = true;
      });

    document
      .querySelectorAll(
        '[aria-checked="true"], [aria-selected="true"], [data-selected="true"], [data-checked="true"], .selected, .is-selected, .checked, .is-checked'
      )
      .forEach(function (el) {
        if (isInsidePopup(el, popupRoots)) return;

        var id = matchSingleAddonId(el.textContent || '');
        if (id) active[id] = true;
      });

    return active;
  }

  function captureProductSelections() {
    var ids = getSelectedProductAddonIds(findPopupRoots());

    setRecentProductSelections(ids);
    return ids;
  }

  function getRecentProductSelections() {
    if (Date.now() - recentProductSelection.timestamp > RECENT_SELECTION_TTL) {
      recentProductSelection = {
        ids: {},
        timestamp: 0
      };
      setPopupBlockState(false);
      return {};
    }

    return recentProductSelection.ids;
  }

  function findAddonRow(input, popupRoot) {
    var el = input.parentElement;
    var depth = 0;
    var best = null;

    while (el && el !== document.body && popupRoot.contains(el) && depth < 10) {
      var text = el.textContent || '';
      var normalisedText = normalise(text);
      var id = matchSingleAddonId(text);
      var isPopupChrome =
        normalisedText.indexOf('you might also like') !== -1 ||
        normalisedText.indexOf('skip this offer') !== -1 ||
        normalisedText.indexOf('add items to cart') !== -1;

      if (id && !isPopupChrome && text.length < 1200) {
        best = {
          el: el,
          id: id
        };
      }

      el = el.parentElement;
      depth++;
    }

    return best;
  }

  function collectPopupAddonRows(popupRoots) {
    var rows = [];
    var seen = [];

    popupRoots.forEach(function (root) {
      root
        .querySelectorAll('input[type="checkbox"], input[type="radio"]')
        .forEach(function (input) {
          var row = findAddonRow(input, root);

          if (!row || seen.indexOf(row.el) !== -1) return;

          seen.push(row.el);
          rows.push(row);
        });
    });

    return rows;
  }

  function hideAddonRow(row) {
    row.el.dataset.fisAddonHidden = 'true';
    row.el.setAttribute('aria-hidden', 'true');
    row.el.style.setProperty('display', 'none', 'important');

    row.el
      .querySelectorAll('input[type="checkbox"], input[type="radio"]')
      .forEach(function (input) {
        input.checked = false;
        input.disabled = true;
        input.dataset.fisAddonHiddenInput = 'true';
      });
  }

  function showAddonRow(row) {
    if (row.el.dataset.fisAddonHidden !== 'true') return;

    row.el.removeAttribute('aria-hidden');
    row.el.style.removeProperty('display');
    delete row.el.dataset.fisAddonHidden;

    row.el
      .querySelectorAll('[data-fis-addon-hidden-input="true"]')
      .forEach(function (input) {
        input.disabled = false;
        delete input.dataset.fisAddonHiddenInput;
      });
  }

  function findButtonByText(root, needle) {
    var match = null;

    root.querySelectorAll('button, a, [role="button"]').forEach(function (button) {
      if (match) return;

      var text = normalise(
        [
          button.textContent,
          button.getAttribute('aria-label'),
          button.getAttribute('title'),
          button.value
        ].join(' ')
      );

      if (text.indexOf(needle) !== -1) match = button;
    });

    return match;
  }

  function dismissPopup(popupRoots) {
    popupRoots.forEach(function (root) {
      hardHidePopupRoot(root);

      if (root.dataset.fisDismissQueued === 'true') return;

      root.dataset.fisDismissQueued = 'true';

      setTimeout(function () {
        var skipBtn = findButtonByText(root, 'skip');

        if (skipBtn) {
          skipBtn.click();
          return;
        }

        var closeBtn =
          root.querySelector('button[aria-label*="Close"], button[aria-label*="close"]') ||
          root.querySelector('button[class*="close"], .modal__close');

        if (closeBtn) closeBtn.click();
      }, 0);
    });
  }

  function processAddons(activeIds, popupRoots) {
    if (!popupRoots.length) return;

    if (hasAddonIds(activeIds)) {
      setPopupBlockState(true);
      popupRoots.forEach(hardHidePopupRoot);
      dismissPopup(popupRoots);
      return;
    }

    setPopupBlockState(false);

    var rows = collectPopupAddonRows(popupRoots);
    var hiddenRows = 0;
    var visibleRows = 0;

    rows.forEach(function (row) {
      if (activeIds[row.id]) {
        hideAddonRow(row);
        hiddenRows++;
      } else {
        showAddonRow(row);
        visibleRows++;
      }
    });

    if (rows.length > 0 && hiddenRows > 0 && visibleRows === 0) {
      dismissPopup(popupRoots);
    }
  }

  var debounceTimer;
  function run(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var popupRoots = findPopupRoots();

      if (!popupRoots.length) return;

      var activeIds = getBlockingAddonIds(popupRoots);

      if (hasAddonIds(activeIds)) {
        processAddons(activeIds, popupRoots);
        return;
      }

      getCartAddonIds().then(function (cartIds) {
        activeIds = mergeIds({}, cartIds);

        processAddons(activeIds, popupRoots);
      });
    }, typeof delay === 'number' ? delay : 50);
  }

  function hookPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        // Refresh cache immediately on cart change so checkout block is instant
        getCartAddonIds().then(updateCartCache);
        run();
      });
    } else {
      setTimeout(hookPubSub, 300);
    }
  }

  function hookCheckoutButton() {
    // Cart drawer checkout — block popup before it appears (no flicker)
    document.addEventListener(
      'click',
      function (event) {
        var btn =
          event.target &&
          event.target.closest &&
          event.target.closest(
            '#CartDrawer-Checkout, button[name="checkout"], .cart__checkout-button, [href*="/checkout"]'
          );

        if (!btn) return;

        var cached = getCachedCartIds();

        if (hasAddonIds(cached)) {
          setRecentProductSelections(cached);
          setPopupBlockState(true);
        }
      },
      true
    );
  }

  function hookSelectionCapture() {
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;

        if (
          target &&
          target.matches &&
          target.matches('input[type="checkbox"], input[type="radio"], select')
        ) {
          setTimeout(function () {
            captureProductSelections();
            run(0);
          }, 0);
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function () {
        captureProductSelections();
        run(0);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var trigger =
          event.target &&
          event.target.closest &&
          event.target.closest('button, input[type="submit"], a, [role="button"]');

        var text = normalise(
          [
            trigger && trigger.textContent,
            trigger && trigger.getAttribute('aria-label'),
            trigger && trigger.getAttribute('title'),
            trigger && trigger.value
          ].join(' ')
        );
        var isCartTrigger =
          trigger &&
          (text.indexOf('add to cart') !== -1 ||
            text.indexOf('add to bag') !== -1 ||
            text.indexOf('add items to cart') !== -1 ||
            trigger.type === 'submit');

        if (isCartTrigger) {
          captureProductSelections();
          run(0);
          return;
        }

        setTimeout(function () {
          captureProductSelections();
          run(0);
        }, 0);
      },
      true
    );
  }

  function hardBlockAddedPopups(mutations) {
    var activeIds = mergeIds({}, getBlockingAddonIds([]));
    mergeIds(activeIds, getCachedCartIds()); // use pre-fetched cart — no async delay
    var roots = [];

    if (!hasAddonIds(activeIds)) return false;

    mutations.forEach(function (mutation) {
      Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
        findPopupRootsInNode(node).forEach(function (root) {
          addUnique(roots, root);
        });
      });
    });

    if (!roots.length) return false;

    setPopupBlockState(true);
    roots.forEach(hardHidePopupRoot);
    dismissPopup(roots);

    return true;
  }

  var observer = new MutationObserver(function (mutations) {
    var blockedPopup = hardBlockAddedPopups(mutations);

    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        if (!blockedPopup) run(0);
        break;
      }
    }
  });

  function init() {
    installHardHideStyles();
    hookPubSub();
    hookCheckoutButton();
    hookSelectionCapture();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    captureProductSelections();
    // Pre-fetch cart so checkout block is instant (no flicker)
    getCartAddonIds().then(updateCartCache);
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
